import NewsApp from 'hb-react/frontoffice/apps/News/startup/NewsAppClient';
import twoColumnsTemplate from 'hb-react/frontoffice/components/BlocksRenderer/templates/TwoColumnsTemplate';
import { useTopicContext } from 'hb-react/frontoffice/contexts/TopicContext';
import withDefaultAppContexts from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

const TopicNewsContainer = (props) => {
  const topicContext = useTopicContext();

  const {
    currentUser,
    topic: { id: topicId },
  } = props;

  const newsUrl = currentUser
    ? Routes.topics_topic_news_index_path(topicId, {
        format: 'json',
      })
    : dynamicTopicResourcePath(
        Routes.topic_news_path(topicId, {
          format: 'json',
        }),
        topicContext,
      );

  const categoriesUrl = currentUser
    ? Routes.categories_topics_topic_news_index_path(topicId)
    : dynamicTopicResourcePath(
        Routes.categories_topic_news_index_path(topicId),
        topicContext,
      );

  const config = {
    custom: {
      page: {
        config: {
          blocks_renderer_template: twoColumnsTemplate.id,
        },
      },
    },
    routes: {
      categories_url: categoriesUrl,
      news_index_url: dynamicTopicResourcePath(
        Routes.topic_news_path(topicId),
        topicContext,
      ),
      news_url: newsUrl,
    },
  };

  return <NewsApp {...props} host="topics" newsUrl={newsUrl} config={config} />;
};

export default withDefaultAppContexts(TopicNewsContainer);
